import EmbedPage from '@/pages/embed-page.vue';
import { RouteNames } from '@/data/routes';
import EmbedCalculatorPage from '@/pages/embed/EmbedCalculatorPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/embed',
  name: RouteNames.EMBED.INDEX,
  component: EmbedPage,
  meta: {
    displayNav: false,
  },
  children: [
    {
      path: 'calculator',
      name: RouteNames.EMBED.CALCULATOR,
      component: EmbedCalculatorPage,
    },
  ],
});
